// @core/api/endpoints/form/create_form_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateFormPolicyRequest,
  FormPolicyResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Create form policy
 * Creates a form policy for a scope entity (organization, team, department). Configures default form settings, limits, and allowed templates.
 */
export async function CreateFormPolicy(
  data: CreateFormPolicyRequest,
  options?: RequestOptions
): Promise<FormPolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/form-policies`;
  const requestOptions = options;
  return client.post<FormPolicyResponse>(requestPath, data, requestOptions);
}
